<script>
  export let active = false;
</script>

<div class="text-item {active ? '' : 'not-active'}">
  <p class="mb-0">
    <slot />
  </p>
</div>
